//@flow
import * as React from 'react';
import { connect } from 'react-redux';
import Datatable from '@lesofi/swarmcolony-datatable';
import * as actions from '../../redux/nemesis/actions';
import Button from '@material-ui/core/Button';
import KeyboardArrowUp from '@material-ui/icons/KeyboardArrowUp';
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown';
import ModeEdit from '@material-ui/icons/Edit';
import Add from '@material-ui/icons/Add';
import Delete from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import ActionConfirmDialog2 from '../../components/ActionConfirmDialog/ActionConfirmDialog2';
import * as actConfDlgActions from '../../redux/actConfDialog/actions';

import type { LineItemsForm$Props } from './flowTypes'
                        
const columnData = [
    { id: 'id', numeric: false, disablePadding: false, label: 'No.', customCol: true, style: { paddingLeft: '5px',paddingRight: '1px', width: '25%'}, noHeader: true },
    { id: 'item_row_index', numeric: false, disablePadding: false, label: 'No.', customCol: true, style: { paddingLeft: '5px',paddingRight: '5px', width: '5%'}, noHeader: false },
    { id: 'item_desc', numeric: false, disablePadding: true, label: 'Description', customCol: true, style: { paddingLeft: '10px', paddingRight: '10px',  width: '30%'},noHeader: false },
    { id: 'item_customer_part_id', numeric: false, disablePadding: true, label: 'Customer Part ID', customCol: true, style: { paddingLeft: '10px', paddingRight: '10px',  width: '15%'},noHeader: false },
    { id: 'item_qty', numeric: false, disablePadding: true, label: 'QTY', customCol: true, style: { paddingLeft: '11px', paddingRight: '11px',  width: '5%'},noHeader: false },
    { id: 'item_price', numeric: false, disablePadding: true, label: 'Price', customCol: true, style: { paddingLeft: '11px', paddingRight: '11px',  width: '10%'},noHeader: false },
    { id: 'item_total', numeric: false, disablePadding: true, label: 'Total', customCol: true, style: { paddingLeft: '11px', paddingRight: '11px',  width: '10%'},noHeader: false },
];

const editLineItem=(id,props)=>{
    const { nemesis } = props;
    const lineItem = nemesis.lineItems.find(item => item.id==id)
    
    props.editLineItem(lineItem);
}

const moveDownLineItem=(id,props)=>{
    const { jwt } = props;
    
    props.moveDownLineItem(jwt,id);
}

const moveUpLineItem=(id,props)=>{
    const { jwt } = props;

    props.moveUpLineItem(jwt,id);
}

const deleteLineItem=(id,props)=>{
    props.lineItemSelectedId(id);
    props.deleteActionDialog();
}

const submitConfirmDelete=(props)=>{
    const { jwt,nemesis } = props;
    props.deleteLineItem(jwt,nemesis.lineItemId);
    props.closeDeleteDialog();
}

const customCol = (col,row,props)=>{
    const { nemesis } = props;
    switch(col.id){
      case 'id':
        const itemIndex=nemesis.lineItems.findIndex(item => item.id==row.id)
        const isFirstItem=itemIndex==0?true:false;
        const isLastItem=(itemIndex==nemesis.lineItems.length-1 && nemesis.page==nemesis.pages)?true:false;
       
        return (
           <div className='container'>
           <div className='row'> 
            <div className='lineItemIconCol'>
                <Tooltip width='10px' id="tooltip-icon" title="Move Up">
                    <div>
                        <Button disabled={isFirstItem} mini aria-label="Move Up" onClick={()=> moveUpLineItem(row.id,props)}  >
                            <KeyboardArrowUp />
                        </Button>
                    </div>
                </Tooltip>
            </div>
            <div className='lineItemIconCol'>
                <Tooltip id="tooltip-icon" title="Move Down"> 
                <div> 
                    <Button mini disabled={isLastItem} aria-label="Move Down" onClick={()=> moveDownLineItem(row.id,props)} >
                        <KeyboardArrowDown />
                    </Button>
                </div>
                </Tooltip>
            </div>
            <div className='lineItemIconCol'>
                <Tooltip id="tooltip-icon" title="Delete">
                <div>    
                    <Button mini aria-label="Delete" onClick={()=> deleteLineItem(row.id,props)} >
                        <Delete />
                    </Button>
                </div>
                </Tooltip> 
            </div>
            </div>
            </div>
        )
      case 'item_total':
         let itemTotal=row[col.id]
         if (itemTotal) {
            itemTotal=parseFloat(itemTotal) 
            itemTotal=itemTotal.toFixed(2)
         }
         return (
            <span onClick={()=>editLineItem(row.id,props)} 
                className='editLink'>
                {itemTotal}
            </span>
         )   

      default:  
        return (
            <span onClick={()=>editLineItem(row.id,props)} 
                className='editLink'>
                {row[col.id]}
            </span>
        )
    }
}

const addButtonOnclick=(e,props)=>{
    e.preventDefault();
    props.openAddEditLineItemForm();
}

class LineItemsForm extends React.Component<LineItemsForm$Props> {
    componentWillMount(){
        this.refreshData();
    }

    componentDidMount(){
    }

    componentDidUpdate(){
        const { nemesis } = this.props;
        if (nemesis.anyChanges){
            this.refreshData();
        }
    }

    refreshData(){
        const { nemesis,jwt,taskAcceptedInfoId } = this.props;
        const { page,pageSize,sortField,sortOrder } = nemesis;
        
        this.props.getLineItems(jwt,(page:any),(pageSize:any),(sortField:any),(sortOrder:any),taskAcceptedInfoId);
    }

    handleChangePage = (event, page) => {
        const nextPage=page+1;    
        const { jwt,nemesis } = this.props;
        this.props.setPage(jwt,nemesis,nextPage);
    };
  
    handleChangeRowsPerPage = event => {
        const pageSize=event.target.value;
        const { jwt,nemesis } = this.props;
        this.props.setPageSize(jwt,nemesis,pageSize);
    };

    handleRequestSort = (event, property) => {
        let order = 'desc';

        const { jwt,nemesis } = this.props;
        const { sortField,sortOrder } = nemesis;
    
        if (sortField === property && sortOrder === 'desc') {
            order = 'asc';
        }
        
        this.props.sortData(jwt,nemesis,property,order)
    };

    handleClick = (event, id)=> {
    }

    handleSearch=(search)=>{
    }

    render(){
        const { nemesis } = this.props;
    
        return (
            <div className='container'>
                <div className='row'>
                    <div className='col-sm'>
                        <Datatable 
                            title={'Line Items'}    
                            totalRows={nemesis.count}
                            order={nemesis.sortOrder}
                            orderBy={nemesis.sortField}
                            rowsPerPage={nemesis.pageSize}
                            page={(nemesis.page:any) - 1}
                            data={nemesis.lineItems}
                            //handleSearch={this.handleSearch}
                            columnData={columnData}
                            handleRequestSort={this.handleRequestSort}
                            handleClick={this.handleClick}
                            handleChangePage={this.handleChangePage}
                            handleChangeRowsPerPage={this.handleChangeRowsPerPage}
                            tableStyle={{width: '100%',minWidth: 800}}
                            customColFunc={customCol}
                            showToolbar={true}
                            addNewOnclick={(e)=> addButtonOnclick(e,this.props)}
                            clientUiProps={this.props}    
                        />
                    </div>
                </div>
                <div className='row'>
                    <div className='col-sm'>
                        <ActionConfirmDialog2 
                            title={'Invoice Items'}
                            message={'Are you sure you want to delete this item?'}
                            submitFunc={()=> submitConfirmDelete(this.props)}
                        /> 
                    </div>
                </div>    
            </div> 
        )
    }
}

const mapStateToProps:any = (state, ownProps) => {
    return {
        nemesis: state.nemesis
    }
}

const mapDispatchToProps:any = (dispatch, ownProps) => {
    return {
        getLineItems: (jwt,page,pageSize,sortField,sortOrder,taskAcceptedInfoId) => {
            dispatch(actions.getLineItems(jwt,page,pageSize,sortField,sortOrder,taskAcceptedInfoId))
        },
        setPage: (jwt,nemesis,page)=>{
          dispatch(actions.setPage(jwt,nemesis,page))
        },
        setPageSize: (jwt,nemesis,pageSize)=>{
          dispatch(actions.setPageSize(jwt,nemesis,pageSize))
        },
        sortData: (jwt,nemesis,sortField,sortOrder)=>{
            dispatch(actions.sortData(jwt,nemesis,sortField,sortOrder))
        },
        editLineItem: (lineItem)=>{
            dispatch(actions.editLineItem(lineItem))
        }, 
        openAddEditLineItemForm: () => {
            dispatch(actions.openAddEditLineItemForm())  
        },
        moveDownLineItem: (jwt,id)=>{
            dispatch(actions.moveDownLineItem(jwt,id))
        },
        moveUpLineItem: (jwt,id)=>{
            dispatch(actions.moveUpLineItem(jwt,id))
        },
        deleteLineItem: (jwt,id)=>{
            dispatch(actions.deleteLineItem(jwt,id))
        },
        deleteActionDialog: ()=> {
            dispatch(actConfDlgActions.openDialog2())    
        },
        closeDeleteDialog: ()=> {
            dispatch(actConfDlgActions.closeDialog2())    
        },
        lineItemSelectedId: (id)=> {
            dispatch(actions.lineItemSelectedId(id))    
        }
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(LineItemsForm);


// WEBPACK FOOTER //
// ./src/views/ProjectNemesis/LineItemsForm.js